import React from "react";
import Table from "@arachnys/styleguide/Table";
import { css } from "styled-components";

import { formatDatetimeString } from "@arachnys/flow-app/src/formatters/formatDateTimeString";
import { DEFAULT_PAGESIZE_S } from "@arachnys/flow-app/src/config";
import { DocumentLink } from "@arachnys/flow-app/src/container/Documents";
import {
    fileTypes,
    statuses,
} from "@arachnys/flow-app/src/page/RequestPortal/BulkRequest/config";
import FileDeletePopup from "@arachnys/flow-app/src/page/RequestPortal/BulkRequest/FileDeletePopup";

const styles = {
    table: css`
        margin: 20px 0;
        border: none !important;
    `,
};

const columns = [
    {
        Header: "Name",
        id: "name",
        accessor: "fileName",
        Cell: row => (
            <DocumentLink
                documentDatum={{
                    documentId: row.original.docstoreId,
                    documentName: row.original.fileName,
                }}
            />
        ),
    },
    {
        Header: "Upload by",
        id: "uploadby",
        maxWidth: 150,
        Cell: row =>
            `${row.original.user.firstName} ${row.original.user.lastName}`,
    },
    {
        Header: "Date Created",
        id: "uploaddate",
        maxWidth: 150,
        accessor: "createdAt",
        Cell: row => formatDatetimeString({ str: row.original.createdAt }),
    },
];

const statusColumn = {
    id: "status",
    Header: "Status",
    accessor: "status",
    maxWidth: 100,
};

const deleteColumn = (refetch, requestStatus) => ({
    Header: "",
    id: "delete",
    width: 40,
    Cell: row => {
        const request = row.original;
        const showDelete =
            (request.fileType === fileTypes.SANITIZED &&
                requestStatus === statuses.SUBMITTED) ||
            (request.fileType === fileTypes.REPORT &&
                requestStatus === statuses.ACCEPTED);
        return showDelete ? (
            <FileDeletePopup
                refetch={refetch}
                docstoreId={request.docstoreId}
                requestId={request.bulkUploadRequestId}
            />
        ) : null;
    },
});

const DetailsTable = ({ data, showStatus, refetch, requestStatus }) => {
    return (
        <Table
            data={data}
            css={styles.table}
            columns={[
                ...columns,
                ...(showStatus ? [statusColumn] : []),
                deleteColumn(refetch, requestStatus),
            ]}
            defaultPageSize={DEFAULT_PAGESIZE_S}
        />
    );
};

export default DetailsTable;
